import { useMemo } from 'react';
import { useTheme } from '@material-ui/core/styles';

const usePolygons = ({ projects, drawAreaMode, drawnAreaPositions }) => {
  const theme = useTheme();
  // 🟢 Polygon for the user-drawn area
  const drawAreaPolygons = useMemo(() => {
    if (!drawAreaMode || drawnAreaPositions.length === 0) return [];

    return [
      {
        id: 'editable-polygon',
        desc: 'Piirretty alue',
        options: {
          strokeColor: theme.palette.primary.main,
          strokeOpacity: 0.6,
          strokeWeight: 2,
          fillColor: theme.palette.primary.main,
          fillOpacity: 0.3,
          clickable: false,
          draggable: true,
          editable: true,
          visible: true,
          zIndex: 1,
        },
        paths: drawnAreaPositions.map((pos) => ({
          lat: Number(pos.latitude),
          lng: Number(pos.longitude),
        })),
      },
    ];
  }, [drawAreaMode, drawnAreaPositions, theme.palette.error.main]);

  // 🔵 Polygons for project-defined proximity areas
  const projectPolygons = useMemo(() => {
    if (!projects) return [];

    return projects
      .filter(
        (p) =>
          p.proximityToClockInRequired === true &&
          p.latitude &&
          p.longitude &&
          p.proximityToClockInType === 'area' &&
          Array.isArray(p.proximityToClockInArea) &&
          p.proximityToClockInArea.length >= 3
      )
      .map((p, index) => ({
        id: `project-area-${index}`,
        desc: `${p.projectKey} - ${p.name}`,
        options: {
          strokeColor: theme.palette.primary.main,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: theme.palette.primary.main,
          fillOpacity: 0.4,
          clickable: false,
          draggable: false,
          editable: false,
          visible: true,
          zIndex: 1,
        },
        paths: p.proximityToClockInArea.map((pos) => ({
          lat: Number(pos.latitude),
          lng: Number(pos.longitude),
        })),
      }));
  }, [projects, theme.palette.primary.main]);

  // ⚪ Combine both types
  const allPolygons = useMemo(() => {
    const combined = [...projectPolygons, ...drawAreaPolygons];
    return combined;
  }, [projectPolygons, drawAreaPolygons]);

  return { drawAreaPolygons, projectPolygons, allPolygons };
};

export default usePolygons;
